import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Vasudhaiva Kutumbakam ~ The World is One Family</p>
    </footer>
  );
};

export default Footer;
